const photoEnhancer = {
  UnlimitedNumberOfSheets: 'Número ilimitado de imagens',
  SupportAllModels: 'Supports todo os models',
  MagnificationAllX: 'Ampliação: 1x, 2x, 4x, 8x',
  OutputImageFormatMore: 'Output image format: JPG, PNG, TIFF',
  NoWatermark: "Sem marca d'água",
  CancelAtAnytime: 'Cancelar a qualquer momento',
  HighPriorityProcessingSpeed: 'Velocidade de processamento de alta prioridade',
  HitPawAIPhotoEnhancer: 'HitPaw Online Photo Enhancer',
  weekDayPrice: 'R$6,28',
  WeekTotalPrice: '$43,99',
  MonthDayPrice: 'R$3,10',
  MonthTotalPrice: 'ER$92,99',
  YearDayPrice: 'R$1,73',
  YearTotalPrice: 'R$632,99',
  Day: 'Dia',
  Monthly: 'Mensalmente',
  Weekly: 'Semanalmente',
  Yearly: 'Anualmente',
};

export default photoEnhancer;
